/**
 * Checks if the provided event is an AutocompleteSelectSubmit event.
 * @param event The event to check.
 * @returns True if the event is an AutocompleteSelectSubmit event, false otherwise.
 * @example if (isAutocompleteSelectSubmit(event)) { ... } // `query` is available
 */
export const isAutocompleteSelectSubmit = (event) => 'item' in event && 'originalQuery' in event;
/**
 * Checks if the given event is an AutocompleteSearchSubmit event.
 * @param event The event to check.
 * @returns True if the event is an AutocompleteSearchSubmit event, false otherwise.
 * @example if (isAutocompleteSearchSubmit(event)) { ... } // `item` and `originalQuery` are available
 */
export const isAutocompleteSearchSubmit = (event) => 'query' in event;
